<template>
	<div>
		<div class="display-1 font-weight-light mb-3">Reporting</div>
		<timezone />
		<v-form>
			<v-row>
				<v-col cols="3">
					<v-menu
						v-model="menuStart"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="startDate"
								label="Report Start"
								prepend-icon="fal fa-calendar-alt fa-sm"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="startDate" @input="dateSelected"></v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="3">
					<v-menu
						v-model="menuEnd"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="endDate"
								label="Report End"
								prepend-icon="fal fa-calendar-alt fa-sm"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="endDate" @input="dateSelected"></v-date-picker>
					</v-menu>
				</v-col>
				<v-spacer></v-spacer>
			</v-row>
			<v-row class="mb-5" >
				<v-col>
					<v-btn color="primary" class="mr-3" :loading="loading" @click="refresh" :disabled="!startDate || !endDate"><v-icon small>far fa-search fa-fw</v-icon> Search</v-btn>
					<v-btn @click="reset">Reset</v-btn>
				</v-col>
			</v-row>
		</v-form>
		<v-row v-if="reportData">
			<v-col>
				<v-btn color="success" :href="excelLink"><v-icon small class="mr-1">fal fa-file-excel</v-icon> Excel Report</v-btn>
				<v-simple-table v-if="reportData.length > 0" class="mt-3">
					<thead>
					<tr>
						<th class="column text-left">Application</th>
						<th class="column text-left">Region</th>
						<th class="column text-left">Analysis Count</th>
						<th class="column text-left">Analysis Devices</th>
						<th class="column text-left">Snapshot Count</th>
						<th class="column text-left">Snapshot Devices</th>
						<th class="column text-left">Report Count</th>
						<th class="column text-left">Report Devices</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="r in  reportData" :key="r.id">
						<td>{{r.name}}</td>
						<td>{{r.region}}</td>
						<td>{{r.analysisCount}}</td>
						<td>{{r.analysisDevices}}</td>
						<td>{{r.snapshotCount}}</td>
						<td>{{r.snapshotDevices}}</td>
						<td>{{r.reportCount}}</td>
						<td>{{r.reportDevices}}</td>
					</tr>
					</tbody>
				</v-simple-table>
				<v-alert
					v-else
					type="info"
				>
					No results
				</v-alert>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import api from "../api";
import timezone	from "../components/timezone.vue";

export default {
	components: {
		timezone,
	},
	data() {
		return {
			menuStart: false,
			menuEnd: false,
			startDate: null,
			endDate: null,
			loading: false,
			reportData: null,
		};
	},
	created() {
		this.endDate = this.dtnow().toFormat("yyyy-MM-dd");
	},
	computed: {
		excelLink() {
			return api.reportExcel({ start: this.startDate, end: this.endDate, offset: this.dtnow().offset });
		},
	},
	methods: {
		dateSelected() {
			this.menuStart = false;
			this.menuEnd = false;
			this.refresh();
		},
		refresh() {
			this.loading = true;
			api.report({ start: this.startDate, end: this.endDate, offset: this.dtnow().offset })
				.then((r) => {
					this.reportData = r.data;
					this.loading = false;
				})
				.catch((e) => { this.showError(e); });
		},
		reset() {
			this.startDate = null;
			this.endDate = this.dtnow().toFormat("yyyy-MM-dd");
			this.reportData = null;
		},
	},
};
</script>
